import React from 'react'

function Relax() {
    return (
        <div>
            <p className='info'>Il piano Relax è l'ideale per te che desideri risparmiare sul prezzo al kWh con 2 ricariche al mese: entro il 5 ricarichi una taglia pari al tuo consumo medio mensile, entro il 20 la differenza.</p>
            <div className="column">
                <div className="customRow">
                    <p className='main'>Cosa paghi?</p>
                    <span className="separ"></span>
                    <p className='secondary'>Prezzo tutto incluso x consumi mensili</p>
                </div>
                <div className="customRow">
                    <p className='main'>Hai sconti?</p>
                    <span className="separ"></span>
                    <p className='secondary'>Si! Se l'incasso della taglia a inizio mese va a buon fine.</p>
                </div>
                <div className="customRow">
                    <p className='main'>Quando paghi i consumi del mese?</p>
                    <span className="separ"></span>
                    <p className='secondary'>A inizio mese incassiamo il tuo consumo medio mensile; l'eventuale differenza alla scadenza della fattura.</p>
                </div>
                <div className="customRow">
                    <p className='main'>Quando sarà attiva?</p>
                    <span className="separ"></span>
                    <p className='secondary'>Dal 01/01/2022</p>
                </div>
            </div>
        </div>
    )
}

export default Relax
